'use client'

import { useEffect } from 'react'

export const usePreventBodyScroll = (isActive: boolean) => {
  useEffect(() => {
    // Calculate the width of the scrollbar. This is the difference between
    // the full window width (including the scrollbar) and the client width (excluding the scrollbar).
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth

    // Store the original styles to restore them later
    const originalOverflow = document.body.style.overflow
    const originalPaddingRight = document.body.style.paddingRight

    if (isActive) {
      document.body.style.overflow = 'hidden'

      // Without this, removing the scrollbar would cause the page content to "jump" due to the body width change.
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`
      }
    } else {
      // Restore the original styles when the effect is inactive
      document.body.style.overflow = originalOverflow
      document.body.style.paddingRight = originalPaddingRight
    }

    return () => {
      document.body.style.overflow = originalOverflow
      document.body.style.paddingRight = originalPaddingRight
    }
  }, [isActive])
}
